var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDropdownIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,2 L18,2 C18.5522847,2 19,2.44771525 19,3 L19,18 C19,18.5522847 18.5522847,19 18,19 L3,19 C2.44771525,19 2,18.5522847 2,18 L2,3 C2,2.44771525 2.44771525,2 3,2 Z M5,5 L5,16 L16,16 L16,5 L5,5 Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "currentColor",
  transform: "translate(10.579462, 9.079462) rotate(45.000000) translate(-10.579462, -9.079462) ",
  points: "13.817631 5.84129342 13.2955128 11.9078893 7.34129342 12.317631"
}))));
export default SvgDropdownIcon;